<template>
  <div class="container">
    <div class=" md:py-12 lg:py-12 py-4">
      <section class="grid lg:grid-cols-3 md:gap-cols-3 gap-cols-1 gap-8">
        <b-card
          class="mb-2"
          no-body
          v-for="(item, index) in course"
          :key="index"
        >
          <div class="overflow-hidden hover-rad-tr relative">
            <img
              :src="$imageURL + '/' + item.icone"
              alt="course-img"
              class="w-full rounded-tl-lg rounded-tr-lg img-zoom card-topimg-h150 object-cover"
            />

            <div class="card-rating">
              4.5
              <i class="fa fa-star text-warning"></i>
            </div>
            <!-- <a href="#" class="card-bookmark"
              ><feather-icon icon="BookmarkIcon"
            /></a> -->
          </div>
          <b-card-text class="p-4">
            <div class="row">
              <div class="col-6">
                <p class="font-semibold fsize12">
                  {{ item.chapter.length }} chapters
                </p>
              </div>
              <div class="col-6 text-right">
                <p class="font-semibold fsize12">01h 49m</p>
              </div>
            </div>
            <h4 class="font-bold fsize16 sm-fsize18 mt-3 mb-6">
              {{ item.name }}
            </h4>
            <div class="row">
              <div class="col-10">
                <p class="font-bold fsize16 sm-fsize12 text-black">
                  ₹ {{ item.discountPrice }}
                  <span class="line-through fsize14 ml-2 mr-4 text-80808099"
                    >₹ {{ item.price }}
                  </span>
                  <span class="text-success fsize14 font-medium"
                    >42 % off
                  </span>
                </p>
              </div>
              <!-- <div class="col-2 text-right">
                <a href="#"><i class="fa fa-shopping-cart fsize12"></i></a>
              </div> -->
            </div>
          </b-card-text>
        </b-card>
      </section>
      <!-- <div class="mt-20 flex justify-center">
        <base-button
          @click="handleclick"
          outline
          type="primary"
          class="px-12 lg:w-1/3 md:w-1/3 lg:text-xl md:text-xl text-sm py-4 font-medium uppercase"
          >View All</base-button
        >
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    userDetails: Object
  },
  data() {
    return {
      courses: [
        {
          id: "01",
          img: require("@/assets/images/courses/1.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        },
        {
          id: "02",
          img: require("@/assets/images/courses/2.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        },
        {
          id: "03",
          img: require("@/assets/images/courses/3.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        },
        {
          id: "04",
          img: require("@/assets/images/courses/4.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        },
        {
          id: "05",
          img: require("@/assets/images/courses/5.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        },
        {
          id: "06",
          img: require("@/assets/images/courses/1.png"),
          rating: "4.9/5",
          time: "01h 49m",
          count: "5,957",
          name: "  Motion Graphics: Create a Nice Typography Animation",
          price: "33.99"
        }
      ]
    };
  },
  methods: {
    // handleclick() {
    //   this.$router.push({ name: "product-all" });
    // },
  },
  computed: {
    ...mapState("auth", ["userData"]),
    course() {
      return this.userDetails.courses;
    }
  }
};
</script>
